import React from 'react';
import TkbAdminLayout from '../components/administration/TkbAdminLayout';

const TkbAdminPage = () => <TkbAdminLayout />;

export default TkbAdminPage;
